/**
 * Middleware для обработки маршрутов в Nuxt.
 *
 * Этот middleware проверяет, заканчивается ли путь URL косой чертой (`/`)
 * и не является ли он корневым (`/`). Если путь не заканчивается косой чертой
 * и он не является корневым, происходит перенаправление на тот же путь, но с
 * добавленной в конце косой чертой.
 *
 * Пример:
 * - `/about` будет перенаправлен на `/about/`
 * - `/` (корень сайта) не будет перенаправлен
 *
 * Это помогает обеспечить единообразие URL для SEO или других целей.
 *
 * @param {RouteLocation} to - Объект маршрута, на который направляется пользователь.
 * @returns {void|Promise<void>} Если текущий путь не соответствует требованиям, будет выполнено перенаправление.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (to.path !== '/' && !to.path.endsWith('/')) {
    const lastSegment = to.path.substring(to.path.lastIndexOf('/') + 1);
    if (lastSegment.includes('.')) return;

    const { path, query, hash } = to;
    const nextPath = path + '/';
    const nextRoute = { path: nextPath, query, hash };
    return navigateTo(nextRoute, { redirectCode: 301 });
  }
});
